export default __webpack_public_path__ + "static/media/plus.b50bc875.svg";